import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scrolling-animation"
export default class extends Controller {
  connect() {
    const items = document.querySelectorAll('.scroll-animation');

    const active = function(entries){
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('inview');
          // io2.unobserve(entry.target);
        } else {
          // entry.target.classList.remove('inview');
        }
      });
    }

    const io2 = new IntersectionObserver(active);
    
    for(let i=0; i < items.length; i++) {
      io2.observe(items[i]);
    }
  }
}
